import React, { useState, useEffect } from 'react'
import { Panel, Message, Row, Form, Col, DatePicker, Input, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import PdfRenderWidgets from '../../pdfWidgets/PdfRenderWidgets'
import TableReport from '../tableReport/TableReport'
import {
  searchProjectconsiderlist,
  downloadProjectconsiderlist,
  GetLogActivity,
  exportLogActivityExcel,
} from '../../../redux/actions/adminReport'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { DATE_PICKER_FORMAT, DD_MM_YYYY, LOCAL_DAY_TH } from '../../../constants/date'
import moment from 'moment'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { tableViewSize } from '../../../utils/tableViewSizeUtil'
import TooltipButton from '../../../components/buttons/TooltipButton'
import { getDownloadFilePath } from '../../../redux/actions/intellectualProperty'
import notification from '../../../utils/notification'

export default function AccessLoggerActivityWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { showCommandButton, isEdit, onChangeIsEdit, header } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isSucceed, setIsSucceed] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})
  const [dataTable, setDataTable] = useState()
  const [loading, setloading] = useState(false)
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(25)
  const [clearValue, setClearValue] = useState(false)
  const [startDates, setStartDates] = useState(moment().format())
  const [endDates, setEndDates] = useState(moment().format())

  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)
  const [viewSize, setViewSize] = useState([])
  const [totalSize, setTotalSize] = useState(0)

  useEffect(() => {
    // console.log('moment().format(DATE_PICKER_FORMAT) => ', moment().format())

    setDataTable(formSchema?.values || [])
    setViewSize(tableViewSize())
    setTotalSize(formSchema?.totalSize)
    setDisplayLength(formSchema?.displayLength)
  }, [])

  const handelGetDataTable = async (data) => {
    console.log('handelGetDataTable => ', data)
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await GetLogActivity({
        projectCode: data.projectCode,
        logStartDate: data.projectStartDate,
        // ? moment(data.projectStartDate).format(DATE_PICKER_FORMAT)
        // : null,
        LogEndDate: data.projectEndDate,
        // ? moment(data.projectEndDate).format(DATE_PICKER_FORMAT)
        // : null,
        email: data.email,
        name: data.name,
        mobileNo: data.mobileNumber,
        contractNo: data.contractNo,
        pageNumber: data.pageNumber || 1,
        pageSize: data.pageSize || 25,
      })

      if (_schema.success) {
        setDataTable(_schema?.model?.form?.values || [])
        setTotalSize(_schema?.model?.form?.totalSize)
        setDisplayLength(_schema?.model?.form?.displayLength)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setErrorMsg({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setErrorMsg({})
      }
    }
    doneLoading()
    setIsLoading(false)

    // setDataTable('ggg')
  }

  const handelCallGetDataTable = (data) => {
    console.log('handelCallGetDataTable => ', data)

    setPage(1)

    const req = {
      projectCode: data.projectCode,
      projectStartDate: data.projectStartDate,
      projectEndDate: data.projectEndDate,
      email: data.email || '',
      name: data.name || '',
      mobileNo: data.mobileNumber || '',
      contractNo: data.contractNo || '',
      pageNumber: 1,
      pageSize: displayLength,
    }

    handelGetDataTable(req)
  }

  const setValueNullField = () => {
    // setDataTable(null)

    const req = {
      // projectCode: data.,
      // logStartDate: '2026-01-05',
      // LogEndDate: '2026-01-06',
      pageNumber: 1,
      pageSize: 25,
    }
    handelGetDataTable(req)

    for (const key in getValues()) {
      setValue(key, null)
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  const handleChangePage = (data, dataKey) => {
    console.log('data =j> ', data)
    console.log('handleChangePage => ', dataKey, displayLength)
    setPage(dataKey)

    const req = {
      projectCode: data.projectCode,
      projectStartDate: data.projectStartDate,
      projectEndDate: data.projectEndDate,
      email: data.email || '',
      name: data.name || '',
      mobileNo: data.mobileNumber || '',
      contractNo: data.contractNo || '',
      pageNumber: dataKey,
      pageSize: displayLength,
    }

    // console.log('gggg 000 => ', req)

    handelGetDataTable(req)
  }

  const handleChangeLength = (data, dataKey) => {
    console.log('data ', data)
    console.log('data key ', dataKey)

    setPage(1)
    setDisplayLength(dataKey)

    const req = {
      projectCode: data.projectCode,
      projectStartDate: data.projectStartDate,
      projectEndDate: data.projectEndDate,
      email: data.email || '',
      name: data.name || '',
      mobileNo: data.mobileNumber || '',
      contractNo: data.contractNo || '',
      pageNumber: 1,
      pageSize: dataKey,
    }
    handelGetDataTable(req)
  }

  const handlePreviewFilePath = async (fileObj) => {
    console.log('file ggg => ', fileObj)
    // return false
    startLoading()
    setIsLoading(true)
    try {
      var file = await getDownloadFilePath(fileObj)
      console.log('file => ', file)
      var fileName = fileObj

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSubmitOnPrint = async (data) => {
    console.log('handleSubmitOnPrint => ', data)
    // return false

    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const request = {
        projectCode: data.projectCode,
        contractNo: data.contractNo,
        name: data.name,
        mobileNumber: data.mobileNumber,
        email: data?.email,
        logStartDate: data?.projectStartDate,
        // ? data?.projectStartDate
        // : moment().format(DATE_PICKER_FORMAT),
        logEndDate: data?.projectEndDate,
        // ? data?.projectEndDate
        // : moment().format(DATE_PICKER_FORMAT),
      }

      console.log('requestttt => ', request)

      const file = await exportLogActivityExcel(request)

      if (file) {
        downloadFile(
          file,
          file.name || `ข้อมูล Activity Log_${moment().format(DATE_PICKER_FORMAT)}`
        )
      }
    } catch (e) {
      console.error('err => ', e)
      // let errorJson = JSON.parse(await e.response.data.text())
      // setIsError(true)
      // handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <>
            <Form>
              <Row>
                {formSchema?.searchObject?.projectStartDate && (
                  <>
                    <Col
                      lg={4}
                      md={4}
                      sm={8}
                      xs={8}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {formSchema?.searchObject?.projectStartDate?.label || ''}
                    </Col>
                    <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                      <ErrorMessage
                        error={errors[formSchema?.searchObject?.projectStartDate?.name]}
                      />
                      <Controller
                        key={formSchema?.searchObject?.projectStartDate?.name}
                        name={formSchema?.searchObject?.projectStartDate?.name}
                        control={control}
                        defaultValue={
                          formSchema?.searchObject?.projectStartDate?.value
                            ? moment(
                                formSchema?.searchObject?.projectStartDate?.value,
                                DATE_PICKER_FORMAT
                              ).toDate()
                            : null
                        }
                        // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                        render={(props) => {
                          return (
                            <DatePicker
                              format={DATE_PICKER_FORMAT}
                              locale={LOCAL_DAY_TH}
                              block
                              value={startDates}
                              onChange={(value) => {
                                const date = moment(value).format(DATE_PICKER_FORMAT)
                                props.onChange(value)
                                setStartDates(value)
                              }}
                              disabledDate={(date) =>
                                endDates && moment(endDates).isBefore(date, new Date())
                              }
                            />
                          )
                        }}
                      />
                    </Col>
                  </>
                )}

                {formSchema?.searchObject?.projectEndDate && (
                  <>
                    <Col
                      lg={4}
                      md={4}
                      sm={8}
                      xs={8}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {formSchema?.searchObject?.projectEndDate?.label || ''}
                    </Col>
                    <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                      <ErrorMessage
                        error={errors[formSchema?.searchObject?.projectEndDate?.name]}
                      />
                      <Controller
                        key={formSchema?.searchObject?.projectEndDate?.name}
                        name={formSchema?.searchObject?.projectEndDate?.name}
                        control={control}
                        defaultValue={
                          formSchema?.searchObject?.projectEndDate?.value
                            ? moment(
                                formSchema?.searchObject?.projectEndDate?.value,
                                DATE_PICKER_FORMAT
                              ).toDate()
                            : null
                        }
                        // rules={isValidators(formSchema?.searchObject?.projectEndDate.validators)}
                        render={(props) => {
                          return (
                            <DatePicker
                              format={DATE_PICKER_FORMAT}
                              locale={LOCAL_DAY_TH}
                              block
                              value={endDates}
                              onChange={(value) => {
                                const date = moment(value).format(DATE_PICKER_FORMAT)
                                props.onChange(value)
                                setEndDates(value)
                              }}
                              disabledDate={(date) =>
                                startDates && moment(startDates).isAfter(date, new Date())
                              }
                            />
                          )
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>
              <Row>
                {formSchema?.searchObject?.projectCode && (
                  <>
                    <Col
                      lg={4}
                      md={4}
                      sm={8}
                      xs={8}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {formSchema?.searchObject?.projectCode?.label || ''}
                    </Col>
                    <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        name={formSchema?.searchObject?.projectCode?.name}
                        defaultValue={formSchema?.searchObject?.projectCode?.value}
                        placeholder={
                          formSchema?.searchObject?.projectCode?.hint || `ระบุรหัสโครงการ`
                        }
                        inputRef={register()}
                      />
                    </Col>
                  </>
                )}

                {formSchema?.searchObject?.contractNo && (
                  <>
                    <Col
                      lg={4}
                      md={4}
                      sm={8}
                      xs={8}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {formSchema?.searchObject?.contractNo?.label || ''}
                    </Col>
                    <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        name={formSchema?.searchObject?.contractNo?.name}
                        defaultValue={formSchema?.searchObject?.contractNo?.value}
                        placeholder={
                          formSchema?.searchObject?.contractNo?.hint || `ระบุเลขที่ข้อตกลง`
                        }
                        inputRef={register()}
                      />
                    </Col>
                  </>
                )}

                {formSchema?.searchObject?.name && (
                  <>
                    <Col
                      lg={4}
                      md={4}
                      sm={8}
                      xs={8}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {formSchema?.searchObject?.name?.label || ''}
                    </Col>
                    <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        name={formSchema?.searchObject?.name?.name}
                        defaultValue={formSchema?.searchObject?.name?.value}
                        placeholder={formSchema?.searchObject?.name?.hint || `ระบุชื่อผู้ใช้งาน`}
                        inputRef={register()}
                      />
                    </Col>
                  </>
                )}

                {formSchema?.searchObject?.mobileNumber && (
                  <>
                    <Col
                      lg={4}
                      md={4}
                      sm={8}
                      xs={8}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {formSchema?.searchObject?.mobileNumber?.label || ''}
                    </Col>
                    <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        name={formSchema?.searchObject?.mobileNumber?.name}
                        defaultValue={formSchema?.searchObject?.mobileNumber?.value}
                        placeholder={formSchema?.searchObject?.mobileNumber?.hint || `ระบุเบอร์โทร`}
                        inputRef={register()}
                      />
                    </Col>
                  </>
                )}

                {formSchema?.searchObject?.email && (
                  <>
                    <Col
                      lg={4}
                      md={4}
                      sm={8}
                      xs={8}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {formSchema?.searchObject?.email?.label || ''}
                    </Col>
                    <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        name={formSchema?.searchObject?.email?.name}
                        defaultValue={formSchema?.searchObject?.email?.value}
                        placeholder={formSchema?.searchObject?.email?.hint || `ระบุอีเมล`}
                        inputRef={register()}
                      />
                    </Col>
                  </>
                )}
              </Row>
            </Form>
            <hr />
            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}
            <ButtonPanelWidget
              isEdit={true}
              isError={isError}
              buttonText={formSchema?.searchObject?.buttonText}
              onPreview={handleSubmit(handelCallGetDataTable)}
              onPrint={handleSubmit(handleSubmitOnPrint)}
              onCancel={(el) => {
                setValueNullField()
              }}
            />
          </>
        )}
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <>
          <Panel shaded header={header || ''} collapsible defaultExpanded style={{ marginTop: 20 }}>
            <Table height={400} data={dataTable || []} wordWrap>
              <Column width={80} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell dataKey="rowNumber" />
              </Column>

              <Column width={120} align="center">
                <HeaderCell>รหัสโครงการ</HeaderCell>
                <Cell dataKey="projectCode" />
              </Column>

              <Column width={120} align="center">
                <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
                <Cell dataKey="contractNo" />
              </Column>

              <Column width={350}>
                <HeaderCell>การเข้าใช้งาน</HeaderCell>
                {/* <Cell dataKey="logTypeName" /> */}
                <Cell>
                  {(rowData) => {
                    if (rowData.pathFile) {
                      return (
                        <>
                          {`${rowData.logTypeName} `}
                          <TooltipButton
                            isStart={true}
                            icon="eye"
                            tooltip={`แสดงไฟล์`}
                            disabled={loading}
                            onClick={(e) => handlePreviewFilePath(rowData.pathFile)}
                          ></TooltipButton>
                        </>
                      )
                    }

                    return rowData.logTypeName
                  }}
                </Cell>
              </Column>

              <Column width={280}>
                <HeaderCell>อีเมล</HeaderCell>
                <Cell dataKey="email" />
              </Column>

              <Column width={180}>
                <HeaderCell>เบอร์โทร</HeaderCell>
                <Cell dataKey="mobileNumber" />
              </Column>

              <Column width={180}>
                <HeaderCell>ชื่อผู้ใช้</HeaderCell>
                <Cell dataKey="userName" />
              </Column>

              <Column width={180}>
                <HeaderCell>ประเภทเข้าใช้งาน</HeaderCell>
                <Cell dataKey="flagOtp" />
              </Column>

              {/* <Column width={200}>
                <HeaderCell>หน้า</HeaderCell>
                <Cell dataKey="logTypeName" />
              </Column> */}

              {/* <Column width={300}>
                <HeaderCell>API Path</HeaderCell>
                <Cell dataKey="apiPath" />
              </Column> */}

              <Column width={220} align="center" fixed="right">
                <HeaderCell>วันที่-เวลา</HeaderCell>
                <Cell dataKey="createDate" />
              </Column>
            </Table>

            <TablePagination
              lengthMenu={viewSize}
              activePage={page}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total} รายการ`}</>
              }}
              displayLength={displayLength || 25}
              total={totalSize || 1}
              // onChangePage={handleChangePage}
              onChangePage={handleSubmit(handleChangePage)}
              onChangeLength={handleSubmit(handleChangeLength)}
            />
          </Panel>
          <br />
        </>
      )}
    </>
  )
}
